import { useMemo } from 'react';

import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { ActionItem, ActionLabel, ActionsDropdown, OnSelectedAction } from '@hsp/react-component-library';

import { IClientGroup } from '@t/user/client-group.model';

import { s } from '@u/strings';

const columnHelper = createColumnHelper<IClientGroup>();

export const useClientGroupColumns = (
  onAction: OnSelectedAction<IClientGroup>
  // next line disabled because the display column cannot be typed
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): ColumnDef<IClientGroup, any>[] => {
  return useMemo(
    () => [
      columnHelper.accessor('clientGroup', {
        cell: (props) => props.getValue(),
        header: s(['Site.Client', 'Site.Group']),
      }),
      columnHelper.accessor('description', {
        cell: (props) => props.getValue(),
        header: s('Site.Description'),
      }),
      columnHelper.accessor('clientNumber', {
        cell: (props) => props.getValue(),
        header: s('Site.ClientNumber'),
      }),
      columnHelper.display({
        cell: ({ row: { original: value } }) => {
          return (
            <div>
              <ActionsDropdown onSelected={onAction}>
                <ActionLabel>{s('Site.Actions')}</ActionLabel>
                <ActionItem
                  action="edit"
                  icon={'edit'}
                  value={value}>
                  {s('Site.Edit')}
                </ActionItem>
                <ActionItem
                  action="remove"
                  icon={'trash'}
                  value={value}>
                  {s('Site.Remove')}
                </ActionItem>
              </ActionsDropdown>
            </div>
          );
        },
        header: () => <div className="d-flex justify-content-center">{s('Site.Actions')}</div>,
        id: 'actions',
        size: 100,
      }),
    ],
    [onAction]
  );
};
